var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatHistoryBox"},[_vm._m(0),_c('div',{ref:"talksRef",staticClass:"talksBox scrollStyle"},_vm._l((_vm.chatList),function(item,index){return _c('div',{key:item.id,on:{"click":function($event){return _vm.startChat(item)}}},[_c('Msg',{attrs:{"news":item,"msgType":"chat","itemKey":{
          avatar: 'avatarFileUrl',
          textTitle: 'name',
          textContent: 'describe',
        }}})],1)}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v("你的AI助手")])])
}]

export { render, staticRenderFns }